/* eslint-disable camelcase */
import { Component, Vue } from 'vue-property-decorator'
import { ComplementaryOperation } from '@/api/operations/models/complementary-operation'
import { Nullable } from '@/shared/types/app.types'
import sessionStore from '@/session/sessionStore'

@Component
export class ComplementaryOperationGuardMixin extends Vue {
    /// GUARD OPERATIONS ///

    $_canCreateComplementary(): boolean {
        return this.$_hasOperationInCurrentLaboratory(ComplementaryOperation.CREATE)
    }
    $_canEditComplementary(): boolean {
        return this.$_hasOperationInCurrentLaboratory(ComplementaryOperation.EDIT)
    }
    $_canDeleteComplementary(): boolean {
        return this.$_hasOperationInCurrentLaboratory(ComplementaryOperation.DELETE)
    }

    $_canAttachDocumentToComplementary(): boolean {
        return this.$_hasOperationInCurrentLaboratory(ComplementaryOperation.ATTACH)
    }

    $_canValidateComplementary(currentResponsibleId: Nullable<number>): boolean {
        if (sessionStore.getUserPersonnelId() !== currentResponsibleId &&
            !this.$_hasOperationInCurrentLaboratory(ComplementaryOperation.EDIT)) {
            return false
        }
        return this.$_hasOperationInCurrentLaboratory(ComplementaryOperation.VALIDATE)
    }
    $_canRemoveValidationFromComplementary(): boolean {
        return this.$_hasOperationInCurrentLaboratory(ComplementaryOperation.REMOVE_VALIDATION)
    }

    /// CAN BE ///

    $_canBeDocumentAttachedToComplementary(complementary: any): boolean {
        return complementary?.metadata?.operationGuards?.canBeAttached
    }
}
